import ErrorPage from '@/components/error-page';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/__public')({
  component: RouteComponent,
  errorComponent: ({ reset }) => <ErrorPage reset={reset} />,
});

function RouteComponent() {
  return <Outlet />;
}
